export class ChangerPassword 
{
    newPassword:String;
    confirmPassword:String;
}